import {NodeArticleTeaser} from "../nodes/node--article--teaser";
import {useContext} from "react";
import {Dictionary} from "../../../types/hygiena-types";
import {DictionaryContext} from "../../../context/dictionary-context";

export function ParagraphNewsArticle({paragraph, ...props}) {
  const t = useContext<Dictionary>(DictionaryContext);
  // Filter out any references that no longer exist.
  if (!paragraph?.field_news_article_article || !paragraph?.field_news_article_article?.title) return <></>

  return (
    <NodeArticleTeaser node={paragraph.field_news_article_article} readMoreText={`${t?.all?.read_more}`} fullWidth={false} />
  )
}